import { html, unsafeCSS } from 'lit';
import { property } from 'lit/decorators.js';
import { GzInputSearchWebComponent } from '../../gzInput';
import { InputEvents } from '../../gzInput/types/index';
import { styles as customInputStyles } from '../view/customInput.scss';
import { GzInputWebComponent } from '../../gzInput/component/GzInputWebComponent';

export class GzCustomInputSearchWebComponent extends GzInputSearchWebComponent {
  static get styles() {
    return [...GzInputWebComponent.styles, unsafeCSS(`${customInputStyles}`)];
  }

  @property({ type: Boolean, attribute: true, reflect: true })
  searchDisabled: boolean = false;

  public getInputFieldValue() {
    return this.inputElement ? this.inputElement.value : '';
  }

  protected renderSearchButton() {
    return html`
      <gz-icon-button
        ?disabled="${this.searchDisabled ? this.searchDisabled : !this.searchOnAction}"
        id="searchIcon"
        @click="${this.onInputSearch}"
        class="input--button input--search"
        icon="ds-icon-search"
        size="24"
        fontsize="20"
        buttontype="square"
        buttonfill="quiet"
        buttoncolor="secondary"
      >
      </gz-icon-button>
    `;
  }

  protected onKeyUp(event: KeyboardEvent) {
    if (this.searchDisabled) {
      return;
    }

    super.onKeyUp(event);
  }

  protected handleInputEvent(event: Event) {
    this.onUserInput();
    this.emitInputEvent(InputEvents.CHANGE);
  }

  protected onInputSearch() {
    if (this.searchDisabled) {
      return;
    }

    super.onInputSearch();
  }

  /**
   * This method is overwritten, because we want to overwrite the value property even if searchOnAction is enabled
   * @param e
   */
  public clearInputValue(e: Event) {
    if (!this.inputElement) {
      return;
    }

    e.preventDefault();
    /**
     * Clear the input value and emit the change event
     */
    this.setInputElementValue('');
    this.value = this.inputElement.value;
    this.inputElement.focus();
    this.emitInputEvent(InputEvents.CHANGE);
    this.setCanDelete(false);

    if (this.searchOnAction) {
      this.emitInputEvent(InputEvents.SEARCH);
    }
  }
}
